import { XForm, XFormItem } from './xform';
import {
    XInput,
    XSwitch,
    XCheckbox,
    XCheckboxGroup,
    XRadioGroup,
    XRadio,
    XRadioButton,
} from './formItems';

const install = function (app) {
    app.component(XInput.name, XInput);
    app.component(XForm.name, XForm);
    app.component(XFormItem.name, XFormItem);
    app.component(XSwitch.name, XSwitch);
    app.component(XCheckboxGroup.name, XCheckboxGroup);
    app.component(XCheckbox.name, XCheckbox);
    app.component(XRadioGroup.name, XRadioGroup);
    app.component(XRadio.name, XRadio);
    app.component(XRadioButton.name, XRadioButton);
};

export {
    XInput,
    XSwitch,
    XCheckboxGroup,
    XCheckbox,
    XRadioGroup,
    XRadio,
    XRadioButton,
    XForm,
    XFormItem,
    install,
};
